module.exports = __webpack_public_path__ + "img/oops-forbidden.e6a0c0f5.svg";